import { createTheme as createMuiTheme } from '@mui/material/styles';

import { components } from './components';
import { typography } from './typography';
import { themeConfig } from './theme-config';
import { green, support, greyScale, highlight, neutralDark, neutralLight } from './palette';

export const createTheme = () =>
  createMuiTheme({
    cssVariables: {
      colorSchemeSelector: 'class',
    },

    colorSchemes: {
      light: {
        palette: {
          // --- MUI standard roles (used by components automatically) ---
          primary: {
            main: highlight.darkest,
            light: highlight.dark,
            dark: '#005EA0',
            contrastText: '#FFFFFF',
          },
          secondary: {
            main: neutralDark.dark,
            light: neutralDark.light,
            dark: neutralDark.darkest,
            contrastText: '#FFFFFF',
          },
          success: {
            main: support.success.medium,
            light: support.success.light,
            dark: support.success.dark,
            contrastText: '#FFFFFF',
          },
          warning: {
            main: support.warning.medium,
            light: support.warning.light,
            dark: support.warning.dark,
            contrastText: '#FFFFFF',
          },
          error: {
            main: support.error.medium,
            light: support.error.light,
            dark: support.error.dark,
            contrastText: '#FFFFFF',
          },
          grey: greyScale,
          text: {
            primary: neutralDark.darkest,
            secondary: neutralDark.light,
            disabled: neutralLight.darkest,
          },
          background: {
            default: neutralLight.lightest,
            paper: neutralLight.lightest,
          },
          divider: neutralLight.dark,

          // --- Full color scales (for custom components & sx props) ---
          highlight,
          green,
          neutralLight,
          neutralDark,
          support,
        },
      },
    },

    typography,

    shape: { borderRadius: 8 },

    breakpoints: {
      values: { xs: 0, sm: 375, md: 768, lg: 1024, xl: 1280 },
    },

    components,
  });

export const themeMode = themeConfig.defaultMode;
